export default __webpack_public_path__ + "static/media/intro.ee0747d2.svg";